module.exports = __webpack_public_path__ + "images/bg-image.e7b97285.webp";